import React from 'react';

const ProgressBar = ({ value, maxValue = 100, barColor }) => {
  const numericValue = Number(value);
  const max = Number(maxValue) || 100;
  const progressWidth = Number.isFinite(numericValue) ? Math.min(100, Math.max(0, (numericValue / max) * 100)) : 0;

  return (
    <div className='progress-bar'>
      <div
        className='progress-fill'
        style={{ width: `${progressWidth}%`, background: barColor || '#A1A1A1' }}
      />
    </div>
  );
};

export default ProgressBar;
